import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { CourseCardComponent } from "../../../components/coursesComponents/course-card/course-card.component";
import { courses } from '../../../providers/dummy-data';
import { CommonModule } from '@angular/common';
import { AnalyticsComponent } from "../../../components/coursesComponents/analytics/analytics.component";
import { DetailsComponent } from "../../../components/coursesComponents/details/details.component";
import { OthersComponent } from "../../../components/coursesComponents/others/others.component";
import { ReviewComponent } from "../../../components/coursesComponents/review/review.component";
import { PurchasesComponent } from "../../../components/coursesComponents/purchases/purchases.component";
import { GeneralFormComponent } from "../../../components/coursesComponents/general-form/general-form.component";
import { DevicePreviewComponent } from "../../../components/coursesComponents/device-preview/device-preview.component";
import { VideoStructureComponent } from "../../../components/coursesComponents/video-structure/video-structure.component";
import { FlashcardStructureComponent } from "../../../components/coursesComponents/flashcard-structure/flashcard-structure.component";
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';


import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { CourseContent, Type } from './store/course.model';
import { selectCourseContent, selectCourseType } from './store/course.selector';
import { CourseService } from '../course.service';
import { addCourseContent, resetCourseData, setCourseType, loadStructureSuccess } from './store/course.action';

@Component({
  selector: 'app-create-courses',
  standalone: true,
  imports: [CourseCardComponent, CommonModule, AnalyticsComponent, DetailsComponent, OthersComponent, ReviewComponent, PurchasesComponent, GeneralFormComponent, DevicePreviewComponent, VideoStructureComponent, FlashcardStructureComponent],
  templateUrl: './create-courses.component.html',
  styleUrl: './create-courses.component.css'
})
export class CreateCoursesComponent {

  publishedCourses: any[] = [];
  isPublishedCoursesLoading = false;

  contentType: 'video' | 'flashcard' | 'exam' | null = null;


  mode: 'new' | 'edit' | null = null;
  currentTab = 'general';
  courseType$!: Observable<Type | null>;
  courseData$!: Observable<CourseContent | null>;
  courseId: string | null = null;
  isCallGetData: boolean = false;
  isTabDevicePreview = true;

  tabs = [
    { islock: true, name: 'general', value: 'general' },
    { islock: true, name: 'structure', value: 'structure' },
    { islock: true, name: 'details', value: 'details' },
    { islock: true, name: 'other', value: 'other' },
    { islock: true, name: 'review', value: 'review' },
    { islock: true, name: 'purchases', value: 'purchases' },
    { islock: true, name: 'analytics', value: 'analytics' },
  ]
  constructor(
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private store: Store,
    private courseApiService: CourseService,
    private router: Router
  ) {
    // this.route.queryParamMap.subscribe(params => {
    //   const type = params.get('type');
    //   console.log(type);

    //   this.contentType = type === 'video' || type === 'flashcard' || type === 'exam'
    //     ? type
    //     : null;
    // });
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      const type = params.get('type');
      this.contentType = (type && ['video', 'flashcard', 'exam'].includes(type) ? type : null) as 'video' | 'flashcard' | 'exam' | null;
      if (id) {
        this.courseId = id;
      }
    });

    this.route.url.subscribe(urlSegments => {
      const path = urlSegments.join('/');
      this.mode = path.includes('create-course') ? 'new' :
        path.includes('edit-course') ? 'edit' :
          null;
      this.courseType$ = this.store.select(selectCourseType);
      this.courseData$ = this.store.select(selectCourseContent);
      if (this.mode === 'new') this.initializeCreateCouse();
      if (this.mode === 'edit') this.initializeEditCouse();
    });


  }

  ngOnInit() {
    this.getPublishedCourses();
  }

  private normalizeThumbnail(thumbnail: string | null | undefined): string {
    if (!thumbnail) return 'assets/dummy_thumbnail.png';
    if (thumbnail.startsWith('http://') || thumbnail.startsWith('https://')) return thumbnail;
    // backend sometimes returns thumbnail/xxx or thumbnail\\xxx
    return thumbnail.replace('thumbnail/', 'assets/').replace('thumbnail\\', 'assets/');
  }

  private getPublishedCourses(): void {
    if (this.isPublishedCoursesLoading) return;
    this.isPublishedCoursesLoading = true;

    this.courseApiService
      .getAllCourses(1, [{ filter_key: 'is_published', filter_value: 1 }])
      .subscribe({
        next: (res: any) => {
          const list = res?.body?.data ?? [];
          this.publishedCourses = (list ?? []).map((c: any) => ({
            ...c,
            thumbnail: this.normalizeThumbnail(c?.thumbnail),
          }));
          console.log('Published courses:', this.publishedCourses);
          this.isPublishedCoursesLoading = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Failed to load published courses', err);
          this.isPublishedCoursesLoading = false;
        },
      });
  }

  ngOnDestroy() {
    this.store.dispatch(resetCourseData());
  }


  setTab(tab: string) {
    this.currentTab = tab;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  initializeCreateCouse() {
    this.currentTab = 'general';
    this.tabs[0].islock = false;
    console.log(this.contentType);

    const courseTypeState: Type = {
      type: (this.contentType ?? null) as 'video' | 'flashcard' | 'exam',
      mode: this.mode as 'new' | 'edit',
      id: null
    };
    this.store.dispatch(setCourseType({ courseType: courseTypeState }));
  }

  initializeEditCouse() {
    this.currentTab = 'general';
    this.tabs.forEach(tab => tab.islock = false);
    this.store.dispatch(setCourseType({ courseType: { type: this.contentType ?? 'video', mode: this.mode as 'new' | 'edit', id: this.courseId } }));
    this.route.queryParams.subscribe(params => {
      if (params['tab'] && this.tabs.some(tab => tab.value === params['tab'])) {
        this.currentTab = params['tab'];
        if (this.currentTab !== 'general') {
          this.courseData$.pipe(take(1)).subscribe(data => {
            if (!data) this.getCourseContent(this.courseId);
          });
        }
      } else {
        this.currentTab = 'general';
      }
    });
  }


  getCourseContent(id: string | null) {
    if (id) {
      this.courseApiService.getCourseContent(id).subscribe((res: any) => {
        try {
          if (res.body.status === 'success') {
            if (res.body.data) {
              this.store.dispatch(addCourseContent({ content: res.body.data }));
            }
          }
        } catch (error) {
          console.log(error);
        }
      });
    }
  }

  onCourseStatusChanged(evt: any) {
    const changedCourseId = evt?.courseId ?? this.courseId;
    if (!changedCourseId) return;

    
    this.courseApiService.getStructure(changedCourseId).subscribe((res: any) => {
      try {
        if (res?.body?.status === 'success') {
          this.store.dispatch(loadStructureSuccess({ structure: res.body.data ?? [], course_id: changedCourseId }));
        }
      } catch (e) {
        console.error(e);
      }
    });
    this.getCourseContent(changedCourseId);
  }

  @ViewChild('previewWrapper', { static: false }) wrapperRef!: ElementRef;
scale = 1;
contentWidth = 600;  
contentHeight = 800; 

ngAfterViewInit() {
  // Small delay to ensure DOM is fully rendered
  setTimeout(() => {
    this.calculateScale();
  }, 100);
}

@HostListener('window:resize')
onResize() {
  this.calculateScale();
}

calculateScale() {
  if (!this.wrapperRef) return;
  
  const wrapper = this.wrapperRef.nativeElement;
  const wrapperWidth = wrapper.offsetWidth;
  const wrapperHeight = wrapper.offsetHeight;
  
  console.log('Wrapper dimensions:', wrapperWidth, wrapperHeight);
  
  // Calculate scale to fit content inside wrapper
  const scaleX = wrapperWidth / this.contentWidth;
  const scaleY = wrapperHeight / this.contentHeight;
  
  // Use the smaller scale to ensure content fits completely
  this.scale = Math.min(scaleX, scaleY);
  
  console.log('Calculated scale:', this.scale);
  
  this.cdr.detectChanges();
}



}
